export default __webpack_public_path__ + "static/media/ubi2.d835adb5.jpg";